import { removeLocaleFromPath2 } from 'functions/language'

import { seriousRelationshipPath } from './Special.paths'

export const isSeriousRelaionship = (url: string) =>
  removeLocaleFromPath2(url).startsWith(seriousRelationshipPath)
